<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <ValidationObserver
    ref="observer"
    v-slot="{ valid, dirty }"
  >
    <div class="baseline">
      <div class="baseline__titleSection">
        <img
          :src="calendarSVG"
          alt="Icon"
          width="20px"
          height="20px"
        >
        <p>
          {{ $t('massBalance.periodOfTheBaseline') }}
        </p>
      </div>
      <div>
        <VSelect
          v-model="baselineData.reportingPeriod"
          :items="baselineDataPeriods"
          :label="$t('massBalance.reportingPeriod')"
          outlined
          :rules="{ required: true, min: 1, max: 20 }"
          dense
          @change="onChangeReportingPeriod(baselineData.reportingPeriod)"
        />
      </div>

      <div
        v-if="baselineData.reportingPeriod !== 'annual'"
      >
        <VSelect
          v-model="baselineData.startDate"
          :items="monthsList"
          :label="$t('massBalance.e4Form.boilerOperatingParameters.startPeriod')"
          outlined
          dense
          :rules="{ required: true, min: 1, max: 20 }"
        />
      </div>


      <!-- Annuel -->
      <v-row
        v-if="baselineData.reportingPeriod === 'annual'"
      >
        <v-col
          cols="12"
          md="6"
        >
          <VTextField
            v-model="baselineData.startDate"
            :label="$t('massBalance.e4Form.boilerOperatingParameters.rangeOfTime')"
            outlined
            dense
            style="text-align: left;"
            :rules="{ required: true, min: 1, max: 20 }"
          />
        </v-col>
      </v-row>

      <div
        class="subBarre"
      />
      <!-- ------------------------------------------------------------------- -->


      <v-container
        v-if="baselineData.reportingPeriod && baselineData.startDate"
        style="padding: 0px;"
        fluid
        fillWidth
      >
        <v-table
          height="300px"
          fixedHeader
          bordered
          density="compact"

          style="margin: none; padding: 0 !important; border-collapse: collapse;"
        >
          <thead>
            <tr
              style="background-color:#26384B; color: white; height: 40px;"
            >
              <th
                width="150"
                style="font-weight: 400; text-align: left; padding-left: 10px; border-right: 1px solid white;"
              >
                {{ $t('massBalance.savings') }}
              </th>
              <th
                width="150"
                style="font-weight: 400;border-right: 1px solid white;"
              >
                {{ $t('massBalance.e4Form.baselineData.columnTitles.waterSavingsBaseline') }}
              </th>
              <th
                width="150"
                style="font-weight: 400; border-right: 1px solid white;"
              >
                {{ $t('massBalance.e4Form.baselineData.columnTitles.steamProductionBaseline') }}
              </th>
              <!-- La dernière colonne est subdivisée dynamiquement -->
              <th
                v-if="e4Config.boilerOperatingParameters.energyBalanceType === E4_FUEL"
                width="600"
                :colspan="e4Config.boilerOperatingParameters.fuels.length"
                style="font-weight: 400;"
              >
                {{ $t('massBalance.e4Form.baselineData.columnTitles.energySavingsBaseline') }}
              </th>
            </tr>
          </thead>
          <tbody
            style="max-height: 50px !important; color: #26384B; font-weight: 400;"
          >
            <tr
              v-if="e4Config.boilerOperatingParameters.energyBalanceType === E4_FUEL"
            >
              <td
                style="font-weight: 400; text-align: left; padding-left: 10px; border: 1px solid black;"
              />
              <td
                style="font-weight: 400; border: 1px solid black;"
              />
              <td
                style="font-weight: 400; border: 1px solid black;"
              />
              <td
                v-for="(combustible, index) in e4Config.boilerOperatingParameters.fuels"
                :key="index"
                :style="`font-weight: 400; border: 1px solid black; text-align: center;
                width: ${600 / e4Config.boilerOperatingParameters.fuels.length}px;`"
              >
                {{ $t('massBalance.combustible') }} {{ index + 1 }} : {{ getFuelTranslation(combustible.fuelName) }}
              </td>
            </tr>

            <tr>
              <td
                style="font-weight: 400; text-align: left; padding-left: 10px; border: 1px solid black; height: 100px;"
              >
                {{ $t('massBalance.reportUnit') }}
              </td>
              <td
                style="font-weight: 400; border: 1px solid black;"
              >
                <VSelect
                  v-model="baselineData.waterSavingReport.unit"
                  :items="waterSavingReportUnits"
                  dense
                  :label="$t('massBalance.e4Form.labels.unit')"
                  :rules="{ required: true}"
                />
              </td>

              <td
                style="font-weight: 400; border: 1px solid black;"
              >
                <VSelect
                  v-model="baselineData.steamProductionReport.unit"
                  :items="co2EmissionsReportUnits"
                  dense
                  :label="$t('massBalance.e4Form.labels.unit')"
                  :rules="{ required: true}"
                />
              </td>
              <td
                v-for="(combustible, index) in e4Config.boilerOperatingParameters.fuels"
                v-if="e4Config.boilerOperatingParameters.energyBalanceType === E4_FUEL"
                :key="index"
                style="font-weight: 400; border: 1px solid black; text-align: center;"
              >
                <VTextField
                  v-model="combustible.unit"
                  dense
                  :label="$t('massBalance.e4Form.labels.unit')"
                  :rules="{ required: true}"
                  readonly
                />
              </td>
            </tr>
            <tr
              v-for="(period, index) in baselineData.periods"
              :key="index"
            >
              <td
                v-if="baselineData.reportingPeriod !== 'annual'"
                style="font-weight: 400; text-align: left; padding-left: 10px; border: 1px solid black;"
              >
                {{ capitalizeFirstLetter( $t(`massBalance.e4Form.months.${baselineData.periods[index].startMonth || 'january'}` )) }}
                {{
                  baselineData.reportingPeriod !== 'monthly' && baselineData.reportingPeriod !== 'annual'
                    ? ' - '
                    : ''
                }}

                {{
                  baselineData.reportingPeriod === 'monthly'
                    ? ''
                    : capitalizeFirstLetter($t(`massBalance.e4Form.months.${baselineData.periods[index].endMonth || 'december'}`))
                }}
              </td>

              <td
                v-else
                style="font-weight: 400; text-align: left; padding-left: 10px; border: 1px solid black;"
              >
                {{ baselineData.startDate }}
              </td>

              <td
                style="font-weight: 400; border: 1px solid black;"
              >
                <VTextField
                  v-model.number="baselineData.waterSavingReport.value[index]"
                  :outlined="false"
                  :rules="{ required: true }"
                  class="centerText"
                  field="waterSavingReport"
                  type="number"
                  :label="$t('massBalance.e4Form.baselineData.columnTitles.waterSavingsBaseline')"
                  @change="onInput"
                />
              </td>
              <td
                style="font-weight: 400; border: 1px solid black;"
              >
                <VTextField
                  v-model.number="baselineData.steamProductionReport.value[index]"
                  :outlined="false"
                  :rules="{ required: true }"
                  class="centerText"
                  type="number"
                  :label="$t('massBalance.e4Form.baselineData.columnTitles.steamProductionBaseline')"
                  @change="onInput"
                />
              </td>
              <td
                v-for="(combustible, indexCombustible) in e4Config.boilerOperatingParameters.fuels"
                v-if="e4Config.boilerOperatingParameters.energyBalanceType === E4_FUEL"
                :key="indexCombustible"
                style="font-weight: 400; border: 1px solid black;"
              >
                <VTextField
                  v-model.number="boilerOperatingParameters.fuels[indexCombustible].fuelConsumption[index]"
                  :rules="{ required: true }"
                  class="centerText"
                  type="number"
                  @change="onInput"
                />
              </td>
            </tr>
          </tbody>
        </v-table>
      </v-container>


      <!-- Energy Saving Baseline -->
      <div
        v-if="e4Config.boilerOperatingParameters.energyBalanceType === E4_BOILER"
        class="baseline__titleSection"
      >
        <img
          :src="cloudSVG"
          alt="Icon"
          width="20px"
          height="20px"
        >
        <div>
          {{ $t('massBalance.energySavingsBaseline') }}
        </div>
      </div>

      <div
        v-if="e4Config.boilerOperatingParameters.energyBalanceType === E4_BOILER"
      >
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <VTextField
              v-model.number="baselineData.boilerConsumption.averageBoilerEfficiencyPercentage"
              :label="$t('massBalance.averageBoilerEfficiencyPercentage')"
              outlined
              dense
              :rules="{ required: true}"
              class="centerText"
              @change="onInput"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <VTextField
              v-model.number="baselineData.boilerConsumption.estimatedBoilerEfficiencyPercentage"
              :label="$t('massBalance.estimatedBoilerEfficiency')"
              outlined
              dense
              class="centerText"
              :rules="{ required: true}"
            />
          </v-col>
        </v-row>
      </div>
    </div>
    <SlotScopeWatcher
      :value="dirty"
      @change="$emit('dirty-changed', dirty)"
    />
    <SlotScopeWatcher
      :value="valid"
      @change="$emit('valid-changed', valid)"
    />
  </ValidationObserver>
</template>

<script>
import VSelect from '@/components/shared/widgets/forms/VuetifyInputs/VSelect.vue';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import { mapGetters, mapActions } from 'vuex';
import { ValidationObserver } from 'vee-validate';
import SlotScopeWatcher from '@/components/shared/widgets/forms/validationHelper/SlotScopeWatcher';
import {
    BASELINE_DATA_PERIODS,
    WATER_SAVINGS_UNITS,
    CO2_EMISSIONS_UNITS,
    CONBUSTIBLES_UNITS,
    BALANCETYPEENERGY,
    E4_FUEL,
    E4_BOILER,
} from '@/aquassist-shared/constants/massBalance';
import { map } from 'lodash';

/* Images SVG */
import calendarSVG from '@/assets/images/date-range-calendar.svg';
import cloudSVG from '@/assets/images/cloud_black.svg';
import waterDropSVG from '@/assets/images/water_drop_black.svg';
import leafSVG from '@/assets/images/energy_savings_leaf_black.svg';


export default {
    name: 'BoilerOperatingParameters',
    components: {
        VTextField,
        VSelect,
        ValidationObserver,
        SlotScopeWatcher,
    },
    props: {
        editMode: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            baselineData: {
                // Period
                reportingPeriod: null,
                startDate: null, // String : champ libre pour le mode manual ou mois de  départ pour tous les autres
                periods: [
                    { startMonth: null, endMonth: null },
                ],

                waterSavingReport: {
                    value: [],
                    unit: null,
                },
                steamProductionReport: {
                    value: [],
                    unit: null,
                },

                // EnergySaving
                fuelConsumption: [
                ],
                boilerConsumption: {
                    averageBoilerEfficiencyPercentage: null,
                    estimatedBoilerEfficiencyPercentage: null,
                },
                isInitialized: false,
            },
            boilerOperatingParameters: {},
            months: ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'],
            yearsAllowed: [], // C'est calculé en fonction de l'année actuelle
            tabOpen: {
                waterSaving: false,
                steamProduction: false,
                energySaving: false,
            },
            quantityOfPeriods: {
                annual: 1,
                semiannual: 2,
                quarterly: 4,
                monthly: 12,
            },
            isInitialised: false,
        };
    },

    computed: {
        ...mapGetters([
            'e4Config',
        ]),


        baselineDataPeriods() {
            return map(BASELINE_DATA_PERIODS, value => ({ id: value, name: this.$t(`massBalance.e4Form.periodicities.${value}`) }));
        },
        monthsList() {
            return map(this.months, value => ({ id: value, name: this.$t(`massBalance.e4Form.months.${value}`) }));
        },
        waterSavingReportUnits() {
            return map(WATER_SAVINGS_UNITS, value => ({ id: value, name: this.$t(`massBalance.e4Form.units.${value}`) }));
        },
        co2EmissionsReportUnits() {
            return map(CO2_EMISSIONS_UNITS, value => ({ id: value, name: this.$t(`massBalance.e4Form.units.${value}`) }));
        },
        conbustiblesUnitsList() {
            return CONBUSTIBLES_UNITS || [];
        },
        // SVG images
        calendarSVG() {
            return calendarSVG;
        },
        cloudSVG() {
            return cloudSVG;
        },
        waterDropSVG() {
            return waterDropSVG;
        },
        leafSVG() {
            return leafSVG;
        },
        balanceTypeEnergiesList() {
            return Object.values(BALANCETYPEENERGY || {});
        },
        E4_FUEL() {
            return E4_FUEL;
        },
        E4_BOILER() {
            return E4_BOILER;
        },
    },

    watch: {
        baselineData: {
            deep: true,
            handler() {
                this.onInput();
            },
        },
        // eslint-disable-next-line func-names
        'baselineData.reportingPeriod': function () {
            if (!this.editMode && this.e4Config.boilerOperatingParameters.energyBalanceType === E4_FUEL) {
                for (let i = 0; i < this.e4Config.boilerOperatingParameters.fuels.length; i += 1) {
                    // eslint-disable-next-line max-len
                    this.baselineData.boilerConsumption.fuels[i].fuelConsumption = new Array(this.quantityOfPeriods[this.baselineData.reportingPeriod]).fill(0);
                }
            }
        },
        boilerOperatingParameters: {
            deep: true,
            handler() {
                this.onInput();
            },
        },
        'baselineData.startDate': {
            handler() {
                this.definePeriods();
            },
            deep: true,
            immediate: true,
        },
        'e4Config.boilerOperatingParameters.energyBalanceType': {
            handler() {
                this.boilerOperatingParameters.energyBalanceType = this.e4Config.boilerOperatingParameters.energyBalanceType;
            },
            deep: true,
            immediate: true,
        },

    },


    created() {
        this.boilerOperatingParameters = { ...this.e4Config.boilerOperatingParameters };
        if (this.editMode) {
            this.baselineData = this.e4Config.baselineData;
        }
        this.definePeriods();
        this.isInitialised = true;
    },
    methods: {
        ...mapActions({
            setE4Config: 'setE4Config',
        }),
        onChangeReportingPeriod(periodicity) {
            if (periodicity === 'year') {
                this.baselineData.startDate = new Date();
            }

            this.baselineData.startDate = null;
            // Réinitialiser les tableaux waterSavingConsumption et steamProductionConsumption
            this.baselineData.waterSavingReport = {
                value: [],
                unit: null,
            };
            this.baselineData.steamProductionReport = {
                value: [],
                unit: null,
            };


            // Mettre à jour les tableaux en fonction de la nouvelle période
            for (let i = 0; i < this.quantityOfPeriods[periodicity]; i += 1) {
                this.baselineData.waterSavingReport.value.push(null);
            }

            for (let i = 0; i < this.quantityOfPeriods[periodicity]; i += 1) {
                this.baselineData.steamProductionReport.value.push(null);
            }
        },
        getMonthAfter(month, decallageNumber) {
            const index = this.months.indexOf(month);
            if (index === -1) {
                throw new Error(`Le mois ${month} n'existe pas dans la liste.`);
            }
            const sixMonthsLaterIndex = (index + decallageNumber) % 12;
            return this.months[sixMonthsLaterIndex];
        },
        actionArrow(section) {
            this.tabOpen[section] = !this.tabOpen[section];
        },
        async onInput() {
            if (!this.isInitialised) return;
            this.setE4Config({ baselineData: this.baselineData });
            this.setE4Config({ boilerOperatingParameters: this.boilerOperatingParameters });
        },


        definePeriods() {
            if (this.baselineData.reportingPeriod
            && this.baselineData.startDate
            && this.e4Config.boilerOperatingParameters.energyBalanceType) {
                const generatePeriods = (startDate, steps) => steps.map(([startOffset, endOffset]) => ({
                    startMonth: this.getMonthAfter(startDate, startOffset),
                    endMonth: this.getMonthAfter(startDate, endOffset),
                }));

                switch (this.baselineData.reportingPeriod) {
                    case 'year':
                        this.baselineData.periods = [{ startMonth: 'annual', endMonth: '' }];
                        break;
                    case 'semiannual':
                        this.baselineData.periods = generatePeriods(this.baselineData.startDate, [
                            [0, 5],
                            [6, 11],
                        ]);
                        break;
                    case 'quarterly':
                        this.baselineData.periods = generatePeriods(this.baselineData.startDate, [
                            [0, 2],
                            [3, 5],
                            [6, 8],
                            [9, 11],
                        ]);
                        break;
                    case 'monthly':
                        this.baselineData.periods = generatePeriods(
                            this.baselineData.startDate,
                            Array.from({ length: 12 }, (_, i) => [i, i]),
                        );
                        break;
                    default:
                        this.baselineData.periods = [{ startMonth: '', endMonth: '' }];
                        break;
                }
            }
        },
        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        getFuelTranslation(fuelName) {
            const gasFossilKey = `massBalance.e4Form.fullName.gasFossil.${fuelName}`;
            const electricityKey = `massBalance.e4Form.fullName.electricity.${fuelName}`;
            const pronvincesAndTerritoriesCanadianKey = `massBalance.e4Form.pronvincesAndTerritoriesCanadian.${fuelName}`;

            if (this.$te(gasFossilKey)) {
                return this.$t(gasFossilKey);
            }
            if (this.$te(electricityKey)) {
                return this.$t(electricityKey);
            }
            if (this.$te(pronvincesAndTerritoriesCanadianKey)) {
                return this.$t(pronvincesAndTerritoriesCanadianKey);
            }

            return fuelName;
        },
    },
};
</script>

<style lang="scss">
@import "@/assets/styles/utils/_variables.scss";


  .baseline {
    .centerText input {
      text-align: center;
    }
    &__title {
      margin: 0px !important;
      padding : 0 !important;
      color: #26384B;
    }
    &__titleSection {
      margin: 0px !important;
      padding : 0 !important;
      color: #26384B;
      font-weight: bold;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 8px;

      display: flex;
      flex-direction: row;
      align-items: center;

      margin-bottom: 10px !important;
      margin-top: 10px !important;

      p {
        margin: 0px
      }


    }
    &__lign {
      height: 3px;
      width: 100%;
      background-color: #26384B;
      margin-bottom: 25px;
      margin-top: 25px;
    }

  }


</style>
